// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: 'https://apisdev.onecalltms.com/',
  reportServerUrl: 'https://apisdev.onecalltms.com/',
  CORPORATE_PANEL_URL: "https://fundingsourcedev.onecalltms.com/",
  TRACKING_URL: "https://membercaredev.onecalltms.com/trip-tracking/",
  FARMOUT_AUTH_URL: "https://uber.nemtplatform.com/",
  PROVIDER_URL: 'https://ellipsesdev.onecalltms.com/',
  HMAC_APPLICATION_SECRET: '9Ptj-a6GITQI9-uG0w',
  BROKER_PANEL_URL: 'https://brokerdevapi.onecalltms.com/',
  // OUT_BOUNDS_BASE_URL: 'https://outbounddev.nemtalk.com/', // deepgram
  OUT_BOUNDS_BASE_URL: 'https://moeezusaapi.nemtalk.com/outbound/', // in-house
  OUTBOUND_CONVERSATION_BASE_URL: 'https://lawsuit.qalbs.com/',
  PLANNER_BASE_URL: 'https://nemtplanner.com/',
  HMAC_CONVERSATION_SECRET: 'oP434TxeLaL5',
  FLEET_PANEL_BASE_URL: 'http://fleet.nemtbusiness.com/',
  FLEET_NODE_BASE_URL: 'https://fleetapi.nemtbusiness.com/api/',
  BROKER_HMAC_SECRET: 'ntF2EnIzvPfPdfM82Uq9FB0uLcwJfSlD234d',
  AI_BASE_URL: 'https://ai.nemtbusiness.com/v1'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
